import { withEventBasedMarketTemplateModelState } from '@swf/sports/models/market-templates/eventBased';

import type { SportsMatchFilteringState } from './types';

export const defaultState = withEventBasedMarketTemplateModelState<SportsMatchFilteringState>({
  firstLoadComplete: false,
  loading: false,
  polling: false,
  filters: {
    marketTypes: [],
    durations: []
  },
  templateGroups: [],
  hasPreloaded: false
});
